import Vuex from 'vuex'
import Vue from 'vue'
import WorkService from '../Rest/work'
import ArtistService from '../Rest/artist'
import PacatoService from '../Rest/pacato'
Vue.use(Vuex)

var workService = null;
var artistService = null;
var pacatoService = null;

export const store = new Vuex.Store({
    state: {
        obras: [],
        compositores: [],
        artistas: [],
        configs: [],
        loading: false,
        user:{
            token:false,
            data:{}
        }
    },
    getters:{
        obras: state=>{
            return state.obras;
        },
        artistas: state=>{
            return state.artistas;
        },
        compositores: state=>{
            return state.compositores;
        },
        loading: state =>{
            return state.loading;
        },
        configs: state=>{
            return state.configs;
        },
        platforms_streamings: state=>{
            if(!state.configs.platforms)
                return [];
                
            return state.configs.platforms.filter( function(e){ return (e.type==='streaming'); } );
        },
        is_loggedin:state=>{
            return state.user.token!==false;
        },
        token: state=>{
            return state.user.token.access_token;
        },
        user: state=>{
            return state.user.data;
        }
    },
    mutations: {
        /**
         * Atualização das obras
         * @param {Vuex.Store} state 
         */
        _obras_update(state, obras) {
            //@todo verificar se houve alteração antes de recarregar
            state.obras = obras;

        },
        _artistas_update(state, artistas){
            state.artistas = artistas;
        },
        _compositores_update(state, compositores){
            state.compositores = compositores;
        },
        /**
         * Configs
         * @param {*} state 
         * @param {*} configs 
         */
        _configs(state, configs){
            state.configs = configs;
        },
        /**
         * Muda o status de carregando da página
         * @param {*} state 
         */
        loading(state) {
            state.loading = !state.loading;
        },
        /**
         * Controla o estado do token
         * @param {*} state 
         * @param {*} val 
         */
        token(state, val = false){            
            state.user.token = val;
        },
        /**
         * Controla o estado usuário
         * @param {*} state 
         * @param {*} data 
         */
        user(state, data={}){
            state.user.data = data;
        }
    },
    actions: {
        /**
         * Realiza as funções necessárias para manter o estado das obras atualizado.
         * Há a possibilidade de passar um parametro para obras e atualizar apenas aquela obra
         * ou adicionar um novo.
         * @param {*} context 
         * @param {*} obras 
         */
        obras_update(context, obras = null) {
            
            return new Promise((resolve, reject) => {
                //sendo obras igual a null recarregamos todo o acervo de obras
                if (obras == null) {
                    context.commit("loading");
                    //recarregamos as obras da API
                    workService = WorkService.build();
                    workService.search({}).then(
                        response => {
                           
                            if (Array.isArray(response.items)) {
                                context.commit("_obras_update", response.items);
                                context.commit("loading");
                                resolve();
                            }
                            else{
                                reject(response);
                            }
                        }
                    );
                }
            });
        },
        /**
         * Realiza as funções necessárias para manter o estados dos artistas atualizado.
         * 
         * @param {*} context 
         * @param {*} artistas 
         */
        artistas_update(context, artistas=null){
            //artistService
            return new Promise((resolve, reject) => {
                //sendo artistas igual a null recarregamos todo o acervo de obras
                if (artistas == null) {
                    context.commit("loading");
                    //recarregamos as obras da API   
                    artistService = ArtistService.build();                
                    artistService.search({}).then(
                        response => {                           
                            if (Array.isArray(response.items)) {
                                context.commit("_artistas_update", response.items);
                                context.commit("loading");
                                resolve();
                            }
                            else{
                                reject(response);
                            }
                        }
                    );
                }
            });
        },
        /**
         * Chamado quando o usuário é logado
         * @param {*} context 
         * @param {*} data 
         */
        userAuthenticateData (context, data){
            if(data.token && data.user){
              this.commit('user', data.user);
              this.commit('token', data.token);   
              context.dispatch("pos_login");
            }
          },
        /**
         * Controla o estado do loading full que cobre toda as página
         * @param {*} context 
         */
        loading_full(context){
            context.commit("loading");
        },
        
        load_configs(context){
            pacatoService = PacatoService.build();
            pacatoService.configs().then(e =>{                
                context.commit("_configs", e.items);
            })            
        },
        pos_login(context){
            context.dispatch("load_configs");
            context.dispatch("obras_update");
            context.dispatch("artistas_update");
        }
    }
})